'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

import type { PredefinedGAEvents } from '@natu/utils/events';
import { getEventPayload } from '@natu/utils/getEventPayload';
import { usePageContext } from '@natu/utils/PageContextProvider';

import { Button, type ButtonProps } from './Button';

interface ButtonWithEventProps extends ButtonProps {
  event: PredefinedGAEvents;
  eventProps?: {
    event_cta_position?: string;
    event_cta_section?: string;
    text?: string;
  };
  children: ReactNode;
}

export const ButtonWithEvent = ({ children, event, eventProps, ...rest }: ButtonWithEventProps) => {
  const pathname = usePathname();
  const { isCampaign } = usePageContext() || {};
  const eventPayload = getEventPayload({ pathname, event, eventProps, isCampaign });

  return (
    <Button
      onClick={() => {
        sendGTMEvent({ event, ...eventPayload });
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};
